// extracted by mini-css-extract-plugin
export default {"container":"ContactHistoryDialog_container__7nujU","row":"ContactHistoryDialog_row__Y8Iit","activeBadge":"ContactHistoryDialog_activeBadge__2uEhE"};